export default "__VITE_ASSET__CzhBMkiv__"